<template>
  <div class="flex justify-between items-start gap-3">
    <span class="text-gray-500 whitespace-nowrap">{{ label }}</span>
    <span class="flex items-start gap-2 min-w-0">
      <span class="font-medium break-words text-right min-w-0">
        <slot>{{ value }}</slot>
      </span>
      <button
        v-if="copyText"
        class="pi text-xs cursor-pointer mt-0.5"
        :class="copied ? 'pi-check text-green-600' : 'pi-copy text-gray-400 hover:text-gray-700'"
        :title="copied ? 'Copied!' : 'Copy'"
        @click.stop="copyToClipboard"
      />
    </span>
  </div>
</template>

<script>
export default {
  name: 'CopyableField',
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], default: '' },
  },
  data() {
    return {
      copied: false,
      copyTimeout: null,
    };
  },
  computed: {
    copyText() {
      const v = this.value == null ? '' : String(this.value);
      return v.trim().length > 0 ? v : '';
    },
  },
  beforeUnmount() {
    if (this.copyTimeout) clearTimeout(this.copyTimeout);
  },
  methods: {
    async copyToClipboard() {
      const text = this.copyText;
      if (!text) return;

      try {
        if (navigator?.clipboard?.writeText) {
          await navigator.clipboard.writeText(text);
        } else {
          const el = document.createElement('textarea');
          el.value = text;
          el.setAttribute('readonly', '');
          el.style.position = 'absolute';
          el.style.left = '-9999px';
          document.body.appendChild(el);
          el.select();
          document.execCommand('copy');
          document.body.removeChild(el);
        }

        this.copied = true;
        if (this.copyTimeout) clearTimeout(this.copyTimeout);
        this.copyTimeout = setTimeout(() => {
          this.copied = false;
          this.copyTimeout = null;
        }, 900);
      } catch (e) {
        // silent: clipboard permissions can fail in some contexts
      }
    },
  },
};
</script>

